
                export default function (Component) {
                    Component.__source = "library/components/VabColumnBar/index.vue"
                }
            